// validateUUID returns the passed uuid if valid, otherwise it returns empty string
export const validateUUID = (uuid: string | undefined): string => {
  const matches = uuid?.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
  return matches && matches.length > 0 ? matches[0] : '';
};
